import { render } from "./PatientInsurance.vue?vue&type=template&id=4c540fda&scoped=true"
import script from "./PatientInsurance.vue?vue&type=script&lang=js"
export * from "./PatientInsurance.vue?vue&type=script&lang=js"

import "./PatientInsurance.vue?vue&type=style&index=0&id=4c540fda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c540fda"]])

export default __exports__